// var fitmixOverlay = document.getElementById('fitmix-overlay');
// var emailModal = document.getElementById('vtoEmailModalFittingbox');

// let fitmixInstance = null;
// let fitmixLoading = null;
// let productFrameId = '';

// // Load FitMix SDK only when needed
// async function loadFitMix() {
//   if (window.FitMix) return;

//   if (fitmixLoading) {
//     return fitmixLoading;
//   }

//   fitmixLoading = new Promise((resolve, reject) => {
//     const script = document.createElement('script');

//     script.src = '//vto-advanced-integration-api.fittingbox.com/index.js';

//     script.onload = resolve;
//     script.onerror = reject;

//     document.head.appendChild(script);
//   });

//   return fitmixLoading;
// }

// // Create widget only once
// // Create widget only once
// async function initFitMix() {
//   await loadFitMix();

//   if (fitmixInstance) return fitmixInstance;

//   return new Promise((resolve) => {
//     fitmixInstance = FitMix.createWidget(
//       'my-fitmix-container',
//       {
//         apiKey: '3b3aBgj0Tw7ll29K1pjVJI2Re1Xc4MWZDE7pJs-iKRJ4Wc4lZHucBg',
//         frame: productFrameId,
//         onStopVto: hideModule,
//       },
//       function () {
//         console.log('VTO module is ready.');
//         resolve(fitmixInstance);
//       }
//     );
//   });
// }

// // Try On button
// function onCTAButtonClick(button) {

//   productFrameId = button.dataset.frame;

//   var emailForm = document.querySelector('#vtoEmailModalFittingbox .klaviyo-form-Sd2FTi');

//   if (emailForm && emailForm.innerHTML.trim() === '') {
//     openVto();
//     return;
//   }

//   if (!emailModal) {
//     openVto();
//     return;
//   }

//   emailModal.style.display = 'flex';
//   emailModal.setAttribute('aria-hidden', 'false');
//   document.body.style.overflow = 'hidden';
// }

// // Open VTO
// async function openVto() {
//   await initFitMix();

//   fitmixOverlay.style.display = 'flex';

//   // Small delay gives the iframe time to initialize
//  setTimeout(() => {
//   fitmixInstance.startVto('live');
// }, 100);
// }

// function onCloseAction() {
//   if (fitmixInstance) {
//     fitmixInstance.stopVto();
//   }
// }

// function hideModule() {
//   fitmixOverlay.style.display = 'none';
// }

// if (fitmixOverlay) {
//   fitmixOverlay.addEventListener('click', function (e) {
//     if (e.target === fitmixOverlay) {
//       onCloseAction();
//     }
//   });
// }

// // Klaviyo popup
// (function () {
//   if (!emailModal) return;

//   function closeEmailModal() {
//     emailModal.style.display = 'none';
//     emailModal.setAttribute('aria-hidden', 'true');
//     document.body.style.overflow = '';
//   }

//   function goToVto() {
//     closeEmailModal();
//     setTimeout(openVto, 120);
//   }


// window.addEventListener('klaviyoForms', function (ev) {
//   var t = ev && ev.detail && ev.detail.type;
//   var thisModalOpen = emailModal.style.display !== 'none' && emailModal.style.display !== '';

//   if (!thisModalOpen) return;

//   if (t === 'submit' || t === 'stepSubmit' || t === 'close' || t === 'embedClose') {
//     goToVto();
//   }
// });

//   emailModal.addEventListener('click', function (ev) {
//     if (ev.target === emailModal || ev.target.closest('.close')) {
//       goToVto();
//     }
//   });
// })();



// var fitmixOverlay = document.getElementById('fitmix-overlay');
// var emailModal = document.getElementById('vtoEmailModalFittingbox');
// var vtoTrigger = document.getElementById('vto-trigger'); // ADDED

// const API_KEY = '3b3aBgj0Tw7ll29K1pjVJI2Re1Xc4MWZDE7pJs-iKRJ4Wc4lZHucBg'; // ADDED (pulled out so it can be reused)

// let fitmixInstance = null;
// let fitmixLoading = null;
// let productFrameId = '';

// // ADDED: variant -> barcode lookup
// const VARIANTS = window.__vtoProductVariants || [];

// function getCurrentVariantId() {
//   const form = document.querySelector('form[action*="/cart/add"]');
//   const idInput = form && form.querySelector('input[name="id"]');
//   return idInput ? String(idInput.value) : null;
// }

// function getCurrentFrameId() {
//   const vid = getCurrentVariantId();
//   const variant = vid ? VARIANTS.find(v => String(v.id) === vid) : null;
//   const bc = variant && variant.barcode ? String(variant.barcode).trim() : '';
//   return bc || null;
// }

// // ADDED: availability check + cache
// const availabilityCache = new Map();

// async function checkAvailability(fid) {
//   if (!fid) return false;
//   if (availabilityCache.has(fid)) return availabilityCache.get(fid);

//   try {
//     const res = await fetch(
//       "https://product-api.fittingbox.com/glasses-metadata/availability?apiKey="
//       + encodeURIComponent(API_KEY) + "&uidList=" + encodeURIComponent(fid),
//       { cache: "no-store" }
//     );
//     if (!res.ok) throw new Error("HTTP " + res.status);
//     const data = await res.json();
//     const rec = Array.isArray(data) ? data.find(r => String(r.uid) === String(fid)) : null;
//     const ok = !!(rec && rec.available);
//     availabilityCache.set(fid, ok);
//     return ok;
//   } catch {
//     availabilityCache.set(fid, false);
//     return false;
//   }
// }

// // ADDED: show/hide the button based on availability
// async function refreshButtonVisibility() {
//   if (!vtoTrigger) return;
//   const fid = getCurrentFrameId();

//   if (fid) vtoTrigger.dataset.frame = fid;

//   const ok = fid ? await checkAvailability(fid) : false;

//   if (ok) {
//     vtoTrigger.style.display = 'inline-flex';
//     vtoTrigger.disabled = false;
//   } else {
//     vtoTrigger.style.display = 'none';
//     vtoTrigger.disabled = true;
//   }
// }

// // Load FitMix SDK only when needed
// async function loadFitMix() {
//   if (window.FitMix) return;

//   if (fitmixLoading) {
//     return fitmixLoading;
//   }

//   fitmixLoading = new Promise((resolve, reject) => {
//     const script = document.createElement('script');

//     script.src = '//vto-advanced-integration-api.fittingbox.com/index.js';

//     script.onload = resolve;
//     script.onerror = reject;

//     document.head.appendChild(script);
//   });

//   return fitmixLoading;
// }

// // Create widget only once
// async function initFitMix() {
//   await loadFitMix();

//   if (fitmixInstance) return fitmixInstance;

//   return new Promise((resolve) => {
//     fitmixInstance = FitMix.createWidget(
//       'my-fitmix-container',
//       {
//         apiKey: API_KEY, // CHANGED: reuse the constant instead of a literal
//         frame: productFrameId,
//         onStopVto: hideModule,
//       },
//       function () {
//         console.log('VTO module is ready.');
//         resolve(fitmixInstance);
//       }
//     );
//   });
// }

// // Try On button
// async function onCTAButtonClick(button) { // CHANGED: now async
//   productFrameId = button.dataset.frame;

//   // ADDED: guard so the click can't proceed if it's not actually available
//   const ok = await checkAvailability(productFrameId);
//   if (!ok) return;

//   var emailForm = document.querySelector('#vtoEmailModalFittingbox .klaviyo-form-Sd2FTi');

//   if (emailForm && emailForm.innerHTML.trim() === '') {
//     openVto();
//     return;
//   }

//   if (!emailModal) {
//     openVto();
//     return;
//   }

//   emailModal.style.display = 'flex';
//   emailModal.setAttribute('aria-hidden', 'false');
//   document.body.style.overflow = 'hidden';
// }

// // Open VTO
// async function openVto() {
//   await initFitMix();

//   fitmixOverlay.style.display = 'flex';

//   // Small delay gives the iframe time to initialize
//  setTimeout(() => {
//   fitmixInstance.startVto('live');
// }, 100);
// }

// function onCloseAction() {
//   if (fitmixInstance) {
//     fitmixInstance.stopVto();
//   }
// }

// function hideModule() {
//   // fitmixOverlay.style.display = 'none';
//    if (fitmixInstance) {
//     try { fitmixInstance.stopVto(); } catch (e) {}
//   }
//   fitmixOverlay.style.display = 'none';

//   // Force-kill the camera: destroying the iframe stops any MediaStreamTrack inside it.
//   var oldContainer = document.getElementById('my-fitmix-container');
//   if (oldContainer) {
//     var freshContainer = document.createElement('div');
//     freshContainer.id = 'my-fitmix-container';
//     oldContainer.parentNode.replaceChild(freshContainer, oldContainer);
//   }

//   // The widget instance is now invalid since its iframe is gone —
//   // reset so the next click rebuilds it from scratch.
//   fitmixInstance = null;
// }

// if (fitmixOverlay) {
//   fitmixOverlay.addEventListener('click', function (e) {
//     if (e.target === fitmixOverlay) {
//       onCloseAction();
//     }
//   });
// }

// // Klaviyo popup
// (function () {
//   if (!emailModal) return;

//   function closeEmailModal() {
//     emailModal.style.display = 'none';
//     emailModal.setAttribute('aria-hidden', 'true');
//     document.body.style.overflow = '';
//   }

//   function goToVto() {
//     closeEmailModal();
//     setTimeout(openVto, 120);
//   }


// window.addEventListener('klaviyoForms', function (ev) {
//   var t = ev && ev.detail && ev.detail.type;
//   var thisModalOpen = emailModal.style.display !== 'none' && emailModal.style.display !== '';

//   if (!thisModalOpen) return;

//   if (t === 'submit' || t === 'stepSubmit' || t === 'close' || t === 'embedClose') {
//     goToVto();
//   }
// });

//   emailModal.addEventListener('click', function (ev) {
//     if (ev.target === emailModal || ev.target.closest('.close')) {
//       goToVto();
//     }
//   });
// })();

// // ADDED: init + re-check on variant change
// document.addEventListener('DOMContentLoaded', refreshButtonVisibility);
// if (document.readyState !== 'loading') refreshButtonVisibility();

// document.addEventListener('change', (e) => {
//   if (e.target && e.target.name === 'id') refreshButtonVisibility();
// });
// document.addEventListener('variant:change', refreshButtonVisibility);
// document.addEventListener('product:variant-change', refreshButtonVisibility);




var fitmixOverlay = document.getElementById('fitmix-overlay');
var emailModal = document.getElementById('vtoEmailModalFittingbox');

// ❌ CHANGED: Direct single element select nahi kar rahe ab
// var vtoTrigger = document.getElementById('vto-trigger'); 

const API_KEY = '3b3aBgj0Tw7ll29K1pjVJI2Re1Xc4MWZDE7pJs-iKRJ4Wc4lZHucBg';

let fitmixInstance = null;
let fitmixLoading = null;
let productFrameId = '';

const VARIANTS = window.__vtoProductVariants || [];

function getCurrentVariantId() {
  const form = document.querySelector('form[action*="/cart/add"]');
  const idInput = form && form.querySelector('input[name="id"]');
  return idInput ? String(idInput.value) : null;
}

function getCurrentFrameId() {
  const vid = getCurrentVariantId();
  const variant = vid ? VARIANTS.find(v => String(v.id) === vid) : null;
  const bc = variant && variant.barcode ? String(variant.barcode).trim() : '';
  return bc || null;
}

const availabilityCache = new Map();

async function checkAvailability(fid) {
  if (!fid) return false;
  if (availabilityCache.has(fid)) return availabilityCache.get(fid);

  try {
    const res = await fetch(
      "https://product-api.fittingbox.com/glasses-metadata/availability?apiKey="
      + encodeURIComponent(API_KEY) + "&uidList=" + encodeURIComponent(fid),
      { cache: "no-store" }
    );
    if (!res.ok) throw new Error("HTTP " + res.status);
    const data = await res.json();
    const rec = Array.isArray(data) ? data.find(r => String(r.uid) === String(fid)) : null;
    const ok = !!(rec && rec.available);
    availabilityCache.set(fid, ok);
    return ok;
  } catch {
    availabilityCache.set(fid, false);
    return false;
  }
}

// ✅ FIXED: Ab ye function sabhi .vto-trigger-btn buttons ko update karega
async function refreshButtonVisibility() {
  const vtoTriggers = document.querySelectorAll('.vto-trigger-btn');
  if (!vtoTriggers.length) return;

  const fid = getCurrentFrameId();

  vtoTriggers.forEach(btn => {
    if (fid) btn.dataset.frame = fid;
  });

  const ok = fid ? await checkAvailability(fid) : false;

  vtoTriggers.forEach(btn => {
    if (ok) {
      btn.style.display = 'inline-flex';
      btn.disabled = false;
    } else {
      btn.style.display = 'none';
      btn.disabled = true;
    }
  });
}

// Load FitMix SDK only when needed
async function loadFitMix() {
  if (window.FitMix) return;

  if (fitmixLoading) {
    return fitmixLoading;
  }

  fitmixLoading = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = '//vto-advanced-integration-api.fittingbox.com/index.js';
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });

  return fitmixLoading;
}

// Create widget only once
async function initFitMix() {
  await loadFitMix();

  if (fitmixInstance) return fitmixInstance;

  return new Promise((resolve) => {
    fitmixInstance = FitMix.createWidget(
      'my-fitmix-container',
      {
        apiKey: API_KEY,
        frame: productFrameId,
        onStopVto: hideModule,
      },
      function () {
        console.log('VTO module is ready.');
        resolve(fitmixInstance);
      }
    );
  });
}

// Try On button
async function onCTAButtonClick(button) {
  productFrameId = button.dataset.frame;

  const ok = await checkAvailability(productFrameId);
  if (!ok) return;

  var emailForm = document.querySelector('#vtoEmailModalFittingbox .klaviyo-form-Sd2FTi');

  if (emailForm && emailForm.innerHTML.trim() === '') {
    openVto();
    return;
  }

  if (!emailModal) {
    openVto();
    return;
  }

  emailModal.style.display = 'flex';
  emailModal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

// Open VTO
async function openVto() {
  await initFitMix();

  fitmixOverlay.style.display = 'flex';

  setTimeout(() => {
    fitmixInstance.startVto('live');
  }, 100);
}

function onCloseAction() {
  if (fitmixInstance) {
    fitmixInstance.stopVto();
  }
}

function hideModule() {
  if (fitmixInstance) {
    try { fitmixInstance.stopVto(); } catch (e) {}
  }
  fitmixOverlay.style.display = 'none';

  var oldContainer = document.getElementById('my-fitmix-container');
  if (oldContainer) {
    var freshContainer = document.createElement('div');
    freshContainer.id = 'my-fitmix-container';
    oldContainer.parentNode.replaceChild(freshContainer, oldContainer);
  }

  fitmixInstance = null;
}

if (fitmixOverlay) {
  fitmixOverlay.addEventListener('click', function (e) {
    if (e.target === fitmixOverlay) {
      onCloseAction();
    }
  });
}

// Klaviyo popup
(function () {
  if (!emailModal) return;

  function closeEmailModal() {
    emailModal.style.display = 'none';
    emailModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function goToVto() {
    closeEmailModal();
    setTimeout(openVto, 120);
  }

  window.addEventListener('klaviyoForms', function (ev) {
    var t = ev && ev.detail && ev.detail.type;
    var thisModalOpen = emailModal.style.display !== 'none' && emailModal.style.display !== '';

    if (!thisModalOpen) return;

    if (t === 'submit' || t === 'stepSubmit' || t === 'close' || t === 'embedClose') {
      goToVto();
    }
  });

  emailModal.addEventListener('click', function (ev) {
    if (ev.target === emailModal || ev.target.closest('.close')) {
      goToVto();
    }
  });
})();

// Re-check on page load and variant change
document.addEventListener('DOMContentLoaded', refreshButtonVisibility);
if (document.readyState !== 'loading') refreshButtonVisibility();

document.addEventListener('change', (e) => {
  if (e.target && e.target.name === 'id') refreshButtonVisibility();
});
document.addEventListener('variant:change', refreshButtonVisibility);
document.addEventListener('product:variant-change', refreshButtonVisibility);